
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _40369rsL7EUyaMi_yef_x0mkiREIkJJpDjoBSS9UF3X_45ZgMeta } from "/app/apps/crm/src/app/pages/403.vue?macro=true";
import { default as _404Y02foV1Eyer8Sc7KzQQwsQisGpEocDiHQSSZIcsCBrsMeta } from "/app/apps/crm/src/app/pages/404.vue?macro=true";
import { default as errorPP9OLh4MUGOom37zAL8FSA_hFUDBKfRtbUQzNdebg9gMeta } from "/app/apps/crm/src/app/pages/error.vue?macro=true";
import { default as index5yvgX_lnjktVWbPifAyn6PE8kMK54cnp_UJ6ko2idYQMeta } from "/app/apps/crm/src/app/pages/index.vue?macro=true";
import { default as uiazu_45g5vKiTvi_QwY00ggOwc1wIGMCEVeiQp4WbP8alMMeta } from "/app/apps/crm/src/app/pages/design/ui.vue?macro=true";
import { default as loginfJAFIs_45it3at3_45nubUNVdGqUIoUsRymBHFv4XiEUcbYMeta } from "/app/apps/crm/src/app/pages/auth/login.vue?macro=true";
import { default as resetdEtI_9sIOzf3BB7oPgLOVx2igi9sPyB2B9sGz0NApkYMeta } from "/app/apps/crm/src/app/pages/auth/reset.vue?macro=true";
import { default as inviteqBwAI_Mbv7pdze5XQ8GkEUre5QJYnt9ugHXVONoV1qMMeta } from "/app/apps/crm/src/app/pages/auth/invite.vue?macro=true";
import { default as indexwtCnD_sB4HPm2NOrf_45ipX0UuA9Dkc8LYlxYrWNhx9ZIMeta } from "/app/apps/crm/src/app/pages/fines/index.vue?macro=true";
import { default as indexzuMZwDGsiD9ONlR5WotyZ4ftXpn7Vx07d7GEmr87LsQMeta } from "/app/apps/crm/src/app/pages/inbox/index.vue?macro=true";
import { default as invoiceGC5wpEOSWd5QlRskomRRo_45Ppl_uFSiS7BfPJnxERrUQMeta } from "/app/apps/crm/src/app/pages/pdf/invoice.vue?macro=true";
import { default as restore7UztWy_45tCr9wlkzRyiuDVMFJd6yp9ewXdcfo7l4iXfEMeta } from "/app/apps/crm/src/app/pages/auth/restore.vue?macro=true";
import { default as indexAc4javTUlDlMjlHjCHlcKk6uYk8uf5g_45eoLQjzKKfrUMeta } from "/app/apps/crm/src/app/pages/dealer/index.vue?macro=true";
import { default as registerOQg9zr6oowJB8kKmd9yJOaWDdz_45SaYzbOZM4e2l50ScMeta } from "/app/apps/crm/src/app/pages/auth/register.vue?macro=true";
import { default as profilex6Z3g8ktHIFAGrU91QSWuJ46z8ptRm6Ymv7iNR18dzoMeta } from "/app/apps/crm/src/app/pages/dealer/profile.vue?macro=true";
import { default as indexzupxVswH4gLcSYvCRqXhZe10KfZNmeN1b_45rCTRxebTYMeta } from "/app/apps/crm/src/app/pages/guest/cars/index.vue?macro=true";
import { default as calculatorzBNIVdMFYpAhNVwYsbnYLEWlqn38mGSx0_45sgvONMHicMeta } from "/app/apps/crm/src/app/pages/dealer/calculator.vue?macro=true";
import { default as indexLsMZwcni1XrzQrfYbm_hp9VKO2d5GaQnQdI3hQnWUsIMeta } from "/app/apps/crm/src/app/pages/dealer/cars/index.vue?macro=true";
import { default as _91slug_93kJ6GMx7IM6ST_sq5OEvlUubMIzt7eKkfS4MzRMCJWCgMeta } from "/app/apps/crm/src/app/pages/(docs)/docs/[slug].vue?macro=true";
import { default as indexM3_45qCSnViw9PjHAVpP7WCTjPWjBSLf_AEtS06xj8f6oMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/index.vue?macro=true";
import { default as _91vinCode_93zbRf7Luwb_4508XTvT_d5w9T5hqPfDzumDAflnToyLiJMMeta } from "/app/apps/crm/src/app/pages/guest/cars/[vinCode].vue?macro=true";
import { default as indexsRhMFG9Ngoaru_45xOlvUXjGQP4J26O6U3EyBTEb9JIjAMeta } from "/app/apps/crm/src/app/pages/client-services/index.vue?macro=true";
import { default as indexcx5bE3W9e7DT7WQMHZcEoUPdiemyTv2k49RqanrpU4gMeta } from "/app/apps/crm/src/app/pages/dealer/cars/[id]/index.vue?macro=true";
import { default as indexJQffIfs4szwUjByV5Nj6sX4DvTcc9uRlhz7xS7bAXXcMeta } from "/app/apps/crm/src/app/pages/shipment-requests/index.vue?macro=true";
import { default as createwF6ozrGEF565HAQLYVAbsbQHynNeTh8mvRm3YA_45a2NIMeta } from "/app/apps/crm/src/app/pages/shipment-requests/create.vue?macro=true";
import { default as faqnFJnAUNUi8Vfs4JXflLN6NKtYV1DzDwvw7XLI0vlAb0Meta } from "/app/apps/crm/src/app/pages/(admin)/admin/content/faq.vue?macro=true";
import { default as indexlqIkla2JN2MnjQjhoQsdrboSzjpx3TKm6uprQr6AjtwMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/users/index.vue?macro=true";
import { default as carsR1q3483um9TF1j5GIrhfsJglPpqaI49GqHkt0hQ_45k9oMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/content/cars.vue?macro=true";
import { default as indexwuVGP2BgwQCSll_45KWxbEi2QIjNa6Va_ePPys_3rZGNUMeta } from "/app/apps/crm/src/app/pages/dealer/notifications/index.vue?macro=true";
import { default as messagesXH9DP_gAhoHmLzhQK0raLAt3XuVy4Z0XMPQWf8r4kQgMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/i18n/messages.vue?macro=true";
import { default as edit3_vN04NRml9k6EBNjrdDXt572JMCh_db_SVDxvlz2RkMeta } from "/app/apps/crm/src/app/pages/shipment-requests/[id]/edit.vue?macro=true";
import { default as indexZg34iZbp7_QKzZseFA7NIdykjSfxU2uhLHipDOt0R_8Meta } from "/app/apps/crm/src/app/pages/(admin)/admin/services/index.vue?macro=true";
import { default as companyiVqr0iAF1MTVPR0D0ddVKKh8j_aPnO0nVCVRqVHKrq8Meta } from "/app/apps/crm/src/app/pages/(admin)/admin/content/company.vue?macro=true";
import { default as reviewspPYhMdCeVFMFN7lYj9XZGIjm92_NwpwkoMAvqctKm6AMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/content/reviews.vue?macro=true";
import { default as check_45vin7ZRiJ5f9Nc_45sgsXmDaw8Pu2sgv3CEsK0PP1eQ2MlmsMMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/tools/check-vin.vue?macro=true";
import { default as index_45oldtoZhcq_45ODvzZ__GWj0KAJJWZi0C224ipmT9hidKzaNgMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/users/index-old.vue?macro=true";
import { default as indexDaPFaYox_QyfM799djKhw9uhQNRBA2g9Z5l0ypL6FggMeta } from "/app/apps/crm/src/app/pages/dealer/requested-services/index.vue?macro=true";
import { default as indexF4HaKeT8YelhpFDN9QRe1qO1N5nG_45vtvrI1S2jaeiGoMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/multiplatform/index.vue?macro=true";
import { default as dealersXTX5N2jA2rzHqX71bcyD7nMnsykJKfr_454CR_81m8MhIMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/dealers.vue?macro=true";
import { default as accountsJ6MBwKDQdDs8rlT2bd50zIvkNNiup0c661CfVV8A86EMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/accounts.vue?macro=true";
import { default as auctionslnOa1iBldONAHxH6OhIgA_45H8ZHt847x34YF7_457bQDxcMeta } from "/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/auctions.vue?macro=true";
import { default as _91requestedServiceId_93ZOD7sDpOOmtick2zDkRJGxvf1PlPfas5I2m0CTDOJA4Meta } from "/app/apps/crm/src/app/pages/dealer/cars/[id]/service/[requestedServiceId].vue?macro=true";
import { default as indexzPmtqb3AF38YJVOOH7hLsIVn7V60kpMaqOYukbJTB2cMeta } from "/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/theme/index.vue?macro=true";
import { default as indexX42c8p0LynncfbRnuVa7vaAZ9dA4UbcE_45ngcYUCr5YUMeta } from "/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/users/index.vue?macro=true";
import { default as _91requestedClientServiceId_930QOQoqJ6_45PVaMZZ_45R_xzfmcJ97naIogXEPPM_27nhLMMeta } from "/app/apps/crm/src/app/pages/client-services/service/[requestedClientServiceId].vue?macro=true";
import { default as indexXZIHulQ8TTsEzDuAf7gwhcdq2sHVTxuQT_AwlQGGfZcMeta } from "/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/dashboard/index.vue?macro=true";
export default [
  {
    name: "403___en",
    path: "/403",
    component: () => import("/app/apps/crm/src/app/pages/403.vue")
  },
  {
    name: "403___ru",
    path: "/ru/403",
    component: () => import("/app/apps/crm/src/app/pages/403.vue")
  },
  {
    name: "403___ka",
    path: "/ka/403",
    component: () => import("/app/apps/crm/src/app/pages/403.vue")
  },
  {
    name: "404___en",
    path: "/404",
    component: () => import("/app/apps/crm/src/app/pages/404.vue")
  },
  {
    name: "404___ru",
    path: "/ru/404",
    component: () => import("/app/apps/crm/src/app/pages/404.vue")
  },
  {
    name: "404___ka",
    path: "/ka/404",
    component: () => import("/app/apps/crm/src/app/pages/404.vue")
  },
  {
    name: "error___en",
    path: "/error",
    component: () => import("/app/apps/crm/src/app/pages/error.vue")
  },
  {
    name: "error___ru",
    path: "/ru/error",
    component: () => import("/app/apps/crm/src/app/pages/error.vue")
  },
  {
    name: "error___ka",
    path: "/ka/error",
    component: () => import("/app/apps/crm/src/app/pages/error.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: index5yvgX_lnjktVWbPifAyn6PE8kMK54cnp_UJ6ko2idYQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: index5yvgX_lnjktVWbPifAyn6PE8kMK54cnp_UJ6ko2idYQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/index.vue")
  },
  {
    name: "index___ka",
    path: "/ka",
    meta: index5yvgX_lnjktVWbPifAyn6PE8kMK54cnp_UJ6ko2idYQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/index.vue")
  },
  {
    name: "design-ui___en",
    path: "/design/ui",
    component: () => import("/app/apps/crm/src/app/pages/design/ui.vue")
  },
  {
    name: "design-ui___ru",
    path: "/ru/design/ui",
    component: () => import("/app/apps/crm/src/app/pages/design/ui.vue")
  },
  {
    name: "design-ui___ka",
    path: "/ka/design/ui",
    component: () => import("/app/apps/crm/src/app/pages/design/ui.vue")
  },
  {
    name: "auth-login___en",
    path: "/auth/login",
    meta: loginfJAFIs_45it3at3_45nubUNVdGqUIoUsRymBHFv4XiEUcbYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___ru",
    path: "/ru/auth/login",
    meta: loginfJAFIs_45it3at3_45nubUNVdGqUIoUsRymBHFv4XiEUcbYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___ka",
    path: "/ka/auth/login",
    meta: loginfJAFIs_45it3at3_45nubUNVdGqUIoUsRymBHFv4XiEUcbYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/login.vue")
  },
  {
    name: "auth-reset___en",
    path: "/auth/reset",
    meta: resetdEtI_9sIOzf3BB7oPgLOVx2igi9sPyB2B9sGz0NApkYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/reset.vue")
  },
  {
    name: "auth-reset___ru",
    path: "/ru/auth/reset",
    meta: resetdEtI_9sIOzf3BB7oPgLOVx2igi9sPyB2B9sGz0NApkYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/reset.vue")
  },
  {
    name: "auth-reset___ka",
    path: "/ka/auth/reset",
    meta: resetdEtI_9sIOzf3BB7oPgLOVx2igi9sPyB2B9sGz0NApkYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/reset.vue")
  },
  {
    name: "auth-invite___en",
    path: "/auth/invite",
    meta: inviteqBwAI_Mbv7pdze5XQ8GkEUre5QJYnt9ugHXVONoV1qMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/invite.vue")
  },
  {
    name: "auth-invite___ru",
    path: "/ru/auth/invite",
    meta: inviteqBwAI_Mbv7pdze5XQ8GkEUre5QJYnt9ugHXVONoV1qMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/invite.vue")
  },
  {
    name: "auth-invite___ka",
    path: "/ka/auth/invite",
    meta: inviteqBwAI_Mbv7pdze5XQ8GkEUre5QJYnt9ugHXVONoV1qMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/invite.vue")
  },
  {
    name: "fines___en",
    path: "/fines",
    meta: indexwtCnD_sB4HPm2NOrf_45ipX0UuA9Dkc8LYlxYrWNhx9ZIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/fines/index.vue")
  },
  {
    name: "fines___ru",
    path: "/ru/fines",
    meta: indexwtCnD_sB4HPm2NOrf_45ipX0UuA9Dkc8LYlxYrWNhx9ZIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/fines/index.vue")
  },
  {
    name: "fines___ka",
    path: "/ka/fines",
    meta: indexwtCnD_sB4HPm2NOrf_45ipX0UuA9Dkc8LYlxYrWNhx9ZIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/fines/index.vue")
  },
  {
    name: "inbox___en",
    path: "/inbox",
    meta: indexzuMZwDGsiD9ONlR5WotyZ4ftXpn7Vx07d7GEmr87LsQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/inbox/index.vue")
  },
  {
    name: "inbox___ru",
    path: "/ru/inbox",
    meta: indexzuMZwDGsiD9ONlR5WotyZ4ftXpn7Vx07d7GEmr87LsQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/inbox/index.vue")
  },
  {
    name: "inbox___ka",
    path: "/ka/inbox",
    meta: indexzuMZwDGsiD9ONlR5WotyZ4ftXpn7Vx07d7GEmr87LsQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/inbox/index.vue")
  },
  {
    name: "pdf-invoice___en",
    path: "/pdf/invoice",
    meta: invoiceGC5wpEOSWd5QlRskomRRo_45Ppl_uFSiS7BfPJnxERrUQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/pdf/invoice.vue")
  },
  {
    name: "pdf-invoice___ru",
    path: "/ru/pdf/invoice",
    meta: invoiceGC5wpEOSWd5QlRskomRRo_45Ppl_uFSiS7BfPJnxERrUQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/pdf/invoice.vue")
  },
  {
    name: "pdf-invoice___ka",
    path: "/ka/pdf/invoice",
    meta: invoiceGC5wpEOSWd5QlRskomRRo_45Ppl_uFSiS7BfPJnxERrUQMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/pdf/invoice.vue")
  },
  {
    name: "auth-restore___en",
    path: "/auth/restore",
    meta: restore7UztWy_45tCr9wlkzRyiuDVMFJd6yp9ewXdcfo7l4iXfEMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/restore.vue")
  },
  {
    name: "auth-restore___ru",
    path: "/ru/auth/restore",
    meta: restore7UztWy_45tCr9wlkzRyiuDVMFJd6yp9ewXdcfo7l4iXfEMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/restore.vue")
  },
  {
    name: "auth-restore___ka",
    path: "/ka/auth/restore",
    meta: restore7UztWy_45tCr9wlkzRyiuDVMFJd6yp9ewXdcfo7l4iXfEMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/restore.vue")
  },
  {
    name: "dealer___en",
    path: "/dealer",
    meta: indexAc4javTUlDlMjlHjCHlcKk6uYk8uf5g_45eoLQjzKKfrUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/index.vue")
  },
  {
    name: "dealer___ru",
    path: "/ru/dealer",
    meta: indexAc4javTUlDlMjlHjCHlcKk6uYk8uf5g_45eoLQjzKKfrUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/index.vue")
  },
  {
    name: "dealer___ka",
    path: "/ka/dealer",
    meta: indexAc4javTUlDlMjlHjCHlcKk6uYk8uf5g_45eoLQjzKKfrUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/index.vue")
  },
  {
    name: "auth-register___en",
    path: "/auth/register",
    meta: registerOQg9zr6oowJB8kKmd9yJOaWDdz_45SaYzbOZM4e2l50ScMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___ru",
    path: "/ru/auth/register",
    meta: registerOQg9zr6oowJB8kKmd9yJOaWDdz_45SaYzbOZM4e2l50ScMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___ka",
    path: "/ka/auth/register",
    meta: registerOQg9zr6oowJB8kKmd9yJOaWDdz_45SaYzbOZM4e2l50ScMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/auth/register.vue")
  },
  {
    name: "dealer-profile___en",
    path: "/dealer/profile",
    meta: profilex6Z3g8ktHIFAGrU91QSWuJ46z8ptRm6Ymv7iNR18dzoMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/profile.vue")
  },
  {
    name: "dealer-profile___ru",
    path: "/ru/dealer/profile",
    meta: profilex6Z3g8ktHIFAGrU91QSWuJ46z8ptRm6Ymv7iNR18dzoMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/profile.vue")
  },
  {
    name: "dealer-profile___ka",
    path: "/ka/dealer/profile",
    meta: profilex6Z3g8ktHIFAGrU91QSWuJ46z8ptRm6Ymv7iNR18dzoMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/profile.vue")
  },
  {
    name: "guest-cars___en",
    path: "/guest/cars",
    meta: indexzupxVswH4gLcSYvCRqXhZe10KfZNmeN1b_45rCTRxebTYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/guest/cars/index.vue")
  },
  {
    name: "guest-cars___ru",
    path: "/ru/guest/cars",
    meta: indexzupxVswH4gLcSYvCRqXhZe10KfZNmeN1b_45rCTRxebTYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/guest/cars/index.vue")
  },
  {
    name: "guest-cars___ka",
    path: "/ka/guest/cars",
    meta: indexzupxVswH4gLcSYvCRqXhZe10KfZNmeN1b_45rCTRxebTYMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/guest/cars/index.vue")
  },
  {
    name: "dealer-calculator___en",
    path: "/dealer/calculator",
    meta: calculatorzBNIVdMFYpAhNVwYsbnYLEWlqn38mGSx0_45sgvONMHicMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/calculator.vue")
  },
  {
    name: "dealer-calculator___ru",
    path: "/ru/dealer/calculator",
    meta: calculatorzBNIVdMFYpAhNVwYsbnYLEWlqn38mGSx0_45sgvONMHicMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/calculator.vue")
  },
  {
    name: "dealer-calculator___ka",
    path: "/ka/dealer/calculator",
    meta: calculatorzBNIVdMFYpAhNVwYsbnYLEWlqn38mGSx0_45sgvONMHicMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/calculator.vue")
  },
  {
    name: "dealer-cars___en",
    path: "/dealer/cars",
    meta: indexLsMZwcni1XrzQrfYbm_hp9VKO2d5GaQnQdI3hQnWUsIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/index.vue")
  },
  {
    name: "dealer-cars___ru",
    path: "/ru/dealer/cars",
    meta: indexLsMZwcni1XrzQrfYbm_hp9VKO2d5GaQnQdI3hQnWUsIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/index.vue")
  },
  {
    name: "dealer-cars___ka",
    path: "/ka/dealer/cars",
    meta: indexLsMZwcni1XrzQrfYbm_hp9VKO2d5GaQnQdI3hQnWUsIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/index.vue")
  },
  {
    name: "docs-slug___en",
    path: "/docs/:slug()",
    component: () => import("/app/apps/crm/src/app/pages/(docs)/docs/[slug].vue")
  },
  {
    name: "docs-slug___ru",
    path: "/ru/docs/:slug()",
    component: () => import("/app/apps/crm/src/app/pages/(docs)/docs/[slug].vue")
  },
  {
    name: "docs-slug___ka",
    path: "/ka/docs/:slug()",
    component: () => import("/app/apps/crm/src/app/pages/(docs)/docs/[slug].vue")
  },
  {
    name: "admin___en",
    path: "/admin",
    meta: indexM3_45qCSnViw9PjHAVpP7WCTjPWjBSLf_AEtS06xj8f6oMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/index.vue")
  },
  {
    name: "admin___ru",
    path: "/ru/admin",
    meta: indexM3_45qCSnViw9PjHAVpP7WCTjPWjBSLf_AEtS06xj8f6oMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/index.vue")
  },
  {
    name: "admin___ka",
    path: "/ka/admin",
    meta: indexM3_45qCSnViw9PjHAVpP7WCTjPWjBSLf_AEtS06xj8f6oMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/index.vue")
  },
  {
    name: "guest-cars-vinCode___en",
    path: "/guest/cars/:vinCode()",
    meta: _91vinCode_93zbRf7Luwb_4508XTvT_d5w9T5hqPfDzumDAflnToyLiJMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/guest/cars/[vinCode].vue")
  },
  {
    name: "guest-cars-vinCode___ru",
    path: "/ru/guest/cars/:vinCode()",
    meta: _91vinCode_93zbRf7Luwb_4508XTvT_d5w9T5hqPfDzumDAflnToyLiJMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/guest/cars/[vinCode].vue")
  },
  {
    name: "guest-cars-vinCode___ka",
    path: "/ka/guest/cars/:vinCode()",
    meta: _91vinCode_93zbRf7Luwb_4508XTvT_d5w9T5hqPfDzumDAflnToyLiJMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/guest/cars/[vinCode].vue")
  },
  {
    name: "client-services___en",
    path: "/client-services",
    meta: indexsRhMFG9Ngoaru_45xOlvUXjGQP4J26O6U3EyBTEb9JIjAMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/client-services/index.vue")
  },
  {
    name: "client-services___ru",
    path: "/ru/client-services",
    meta: indexsRhMFG9Ngoaru_45xOlvUXjGQP4J26O6U3EyBTEb9JIjAMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/client-services/index.vue")
  },
  {
    name: "client-services___ka",
    path: "/ka/client-services",
    meta: indexsRhMFG9Ngoaru_45xOlvUXjGQP4J26O6U3EyBTEb9JIjAMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/client-services/index.vue")
  },
  {
    name: "dealer-cars-id___en",
    path: "/dealer/cars/:id()",
    meta: indexcx5bE3W9e7DT7WQMHZcEoUPdiemyTv2k49RqanrpU4gMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/[id]/index.vue")
  },
  {
    name: "dealer-cars-id___ru",
    path: "/ru/dealer/cars/:id()",
    meta: indexcx5bE3W9e7DT7WQMHZcEoUPdiemyTv2k49RqanrpU4gMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/[id]/index.vue")
  },
  {
    name: "dealer-cars-id___ka",
    path: "/ka/dealer/cars/:id()",
    meta: indexcx5bE3W9e7DT7WQMHZcEoUPdiemyTv2k49RqanrpU4gMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/[id]/index.vue")
  },
  {
    name: "shipment-requests___en",
    path: "/shipment-requests",
    meta: indexJQffIfs4szwUjByV5Nj6sX4DvTcc9uRlhz7xS7bAXXcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/index.vue")
  },
  {
    name: "shipment-requests___ru",
    path: "/ru/shipment-requests",
    meta: indexJQffIfs4szwUjByV5Nj6sX4DvTcc9uRlhz7xS7bAXXcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/index.vue")
  },
  {
    name: "shipment-requests___ka",
    path: "/ka/shipment-requests",
    meta: indexJQffIfs4szwUjByV5Nj6sX4DvTcc9uRlhz7xS7bAXXcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/index.vue")
  },
  {
    name: "shipment-requests-create___en",
    path: "/shipment-requests/create",
    meta: createwF6ozrGEF565HAQLYVAbsbQHynNeTh8mvRm3YA_45a2NIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/create.vue")
  },
  {
    name: "shipment-requests-create___ru",
    path: "/ru/shipment-requests/create",
    meta: createwF6ozrGEF565HAQLYVAbsbQHynNeTh8mvRm3YA_45a2NIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/create.vue")
  },
  {
    name: "shipment-requests-create___ka",
    path: "/ka/shipment-requests/create",
    meta: createwF6ozrGEF565HAQLYVAbsbQHynNeTh8mvRm3YA_45a2NIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/create.vue")
  },
  {
    name: "admin-content-faq___en",
    path: "/admin/content/faq",
    meta: faqnFJnAUNUi8Vfs4JXflLN6NKtYV1DzDwvw7XLI0vlAb0Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/faq.vue")
  },
  {
    name: "admin-content-faq___ru",
    path: "/ru/admin/content/faq",
    meta: faqnFJnAUNUi8Vfs4JXflLN6NKtYV1DzDwvw7XLI0vlAb0Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/faq.vue")
  },
  {
    name: "admin-content-faq___ka",
    path: "/ka/admin/content/faq",
    meta: faqnFJnAUNUi8Vfs4JXflLN6NKtYV1DzDwvw7XLI0vlAb0Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/faq.vue")
  },
  {
    name: "admin-users___en",
    path: "/admin/users",
    meta: indexlqIkla2JN2MnjQjhoQsdrboSzjpx3TKm6uprQr6AjtwMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/users/index.vue")
  },
  {
    name: "admin-users___ru",
    path: "/ru/admin/users",
    meta: indexlqIkla2JN2MnjQjhoQsdrboSzjpx3TKm6uprQr6AjtwMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/users/index.vue")
  },
  {
    name: "admin-users___ka",
    path: "/ka/admin/users",
    meta: indexlqIkla2JN2MnjQjhoQsdrboSzjpx3TKm6uprQr6AjtwMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/users/index.vue")
  },
  {
    name: "admin-content-cars___en",
    path: "/admin/content/cars",
    meta: carsR1q3483um9TF1j5GIrhfsJglPpqaI49GqHkt0hQ_45k9oMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/cars.vue")
  },
  {
    name: "admin-content-cars___ru",
    path: "/ru/admin/content/cars",
    meta: carsR1q3483um9TF1j5GIrhfsJglPpqaI49GqHkt0hQ_45k9oMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/cars.vue")
  },
  {
    name: "admin-content-cars___ka",
    path: "/ka/admin/content/cars",
    meta: carsR1q3483um9TF1j5GIrhfsJglPpqaI49GqHkt0hQ_45k9oMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/cars.vue")
  },
  {
    name: "dealer-notifications___en",
    path: "/dealer/notifications",
    meta: indexwuVGP2BgwQCSll_45KWxbEi2QIjNa6Va_ePPys_3rZGNUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/notifications/index.vue")
  },
  {
    name: "dealer-notifications___ru",
    path: "/ru/dealer/notifications",
    meta: indexwuVGP2BgwQCSll_45KWxbEi2QIjNa6Va_ePPys_3rZGNUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/notifications/index.vue")
  },
  {
    name: "dealer-notifications___ka",
    path: "/ka/dealer/notifications",
    meta: indexwuVGP2BgwQCSll_45KWxbEi2QIjNa6Va_ePPys_3rZGNUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/notifications/index.vue")
  },
  {
    name: "admin-i18n-messages___en",
    path: "/admin/i18n/messages",
    meta: messagesXH9DP_gAhoHmLzhQK0raLAt3XuVy4Z0XMPQWf8r4kQgMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/i18n/messages.vue")
  },
  {
    name: "admin-i18n-messages___ru",
    path: "/ru/admin/i18n/messages",
    meta: messagesXH9DP_gAhoHmLzhQK0raLAt3XuVy4Z0XMPQWf8r4kQgMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/i18n/messages.vue")
  },
  {
    name: "admin-i18n-messages___ka",
    path: "/ka/admin/i18n/messages",
    meta: messagesXH9DP_gAhoHmLzhQK0raLAt3XuVy4Z0XMPQWf8r4kQgMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/i18n/messages.vue")
  },
  {
    name: "shipment-requests-id-edit___en",
    path: "/shipment-requests/:id()/edit",
    meta: edit3_vN04NRml9k6EBNjrdDXt572JMCh_db_SVDxvlz2RkMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/[id]/edit.vue")
  },
  {
    name: "shipment-requests-id-edit___ru",
    path: "/ru/shipment-requests/:id()/edit",
    meta: edit3_vN04NRml9k6EBNjrdDXt572JMCh_db_SVDxvlz2RkMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/[id]/edit.vue")
  },
  {
    name: "shipment-requests-id-edit___ka",
    path: "/ka/shipment-requests/:id()/edit",
    meta: edit3_vN04NRml9k6EBNjrdDXt572JMCh_db_SVDxvlz2RkMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/shipment-requests/[id]/edit.vue")
  },
  {
    name: "admin-services___en",
    path: "/admin/services",
    meta: indexZg34iZbp7_QKzZseFA7NIdykjSfxU2uhLHipDOt0R_8Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/services/index.vue")
  },
  {
    name: "admin-services___ru",
    path: "/ru/admin/services",
    meta: indexZg34iZbp7_QKzZseFA7NIdykjSfxU2uhLHipDOt0R_8Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/services/index.vue")
  },
  {
    name: "admin-services___ka",
    path: "/ka/admin/services",
    meta: indexZg34iZbp7_QKzZseFA7NIdykjSfxU2uhLHipDOt0R_8Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/services/index.vue")
  },
  {
    name: "admin-content-company___en",
    path: "/admin/content/company",
    meta: companyiVqr0iAF1MTVPR0D0ddVKKh8j_aPnO0nVCVRqVHKrq8Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/company.vue")
  },
  {
    name: "admin-content-company___ru",
    path: "/ru/admin/content/company",
    meta: companyiVqr0iAF1MTVPR0D0ddVKKh8j_aPnO0nVCVRqVHKrq8Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/company.vue")
  },
  {
    name: "admin-content-company___ka",
    path: "/ka/admin/content/company",
    meta: companyiVqr0iAF1MTVPR0D0ddVKKh8j_aPnO0nVCVRqVHKrq8Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/company.vue")
  },
  {
    name: "admin-content-reviews___en",
    path: "/admin/content/reviews",
    meta: reviewspPYhMdCeVFMFN7lYj9XZGIjm92_NwpwkoMAvqctKm6AMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/reviews.vue")
  },
  {
    name: "admin-content-reviews___ru",
    path: "/ru/admin/content/reviews",
    meta: reviewspPYhMdCeVFMFN7lYj9XZGIjm92_NwpwkoMAvqctKm6AMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/reviews.vue")
  },
  {
    name: "admin-content-reviews___ka",
    path: "/ka/admin/content/reviews",
    meta: reviewspPYhMdCeVFMFN7lYj9XZGIjm92_NwpwkoMAvqctKm6AMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/content/reviews.vue")
  },
  {
    name: "admin-tools-check-vin___en",
    path: "/admin/tools/check-vin",
    meta: check_45vin7ZRiJ5f9Nc_45sgsXmDaw8Pu2sgv3CEsK0PP1eQ2MlmsMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/tools/check-vin.vue")
  },
  {
    name: "admin-tools-check-vin___ru",
    path: "/ru/admin/tools/check-vin",
    meta: check_45vin7ZRiJ5f9Nc_45sgsXmDaw8Pu2sgv3CEsK0PP1eQ2MlmsMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/tools/check-vin.vue")
  },
  {
    name: "admin-tools-check-vin___ka",
    path: "/ka/admin/tools/check-vin",
    meta: check_45vin7ZRiJ5f9Nc_45sgsXmDaw8Pu2sgv3CEsK0PP1eQ2MlmsMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/tools/check-vin.vue")
  },
  {
    name: "admin-users-index-old___en",
    path: "/admin/users/index-old",
    meta: index_45oldtoZhcq_45ODvzZ__GWj0KAJJWZi0C224ipmT9hidKzaNgMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/users/index-old.vue")
  },
  {
    name: "admin-users-index-old___ru",
    path: "/ru/admin/users/index-old",
    meta: index_45oldtoZhcq_45ODvzZ__GWj0KAJJWZi0C224ipmT9hidKzaNgMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/users/index-old.vue")
  },
  {
    name: "admin-users-index-old___ka",
    path: "/ka/admin/users/index-old",
    meta: index_45oldtoZhcq_45ODvzZ__GWj0KAJJWZi0C224ipmT9hidKzaNgMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/users/index-old.vue")
  },
  {
    name: "dealer-requested-services___en",
    path: "/dealer/requested-services",
    meta: indexDaPFaYox_QyfM799djKhw9uhQNRBA2g9Z5l0ypL6FggMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/requested-services/index.vue")
  },
  {
    name: "dealer-requested-services___ru",
    path: "/ru/dealer/requested-services",
    meta: indexDaPFaYox_QyfM799djKhw9uhQNRBA2g9Z5l0ypL6FggMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/requested-services/index.vue")
  },
  {
    name: "dealer-requested-services___ka",
    path: "/ka/dealer/requested-services",
    meta: indexDaPFaYox_QyfM799djKhw9uhQNRBA2g9Z5l0ypL6FggMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/requested-services/index.vue")
  },
  {
    name: "admin-multiplatform___en",
    path: "/admin/multiplatform",
    meta: indexF4HaKeT8YelhpFDN9QRe1qO1N5nG_45vtvrI1S2jaeiGoMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiplatform/index.vue")
  },
  {
    name: "admin-multiplatform___ru",
    path: "/ru/admin/multiplatform",
    meta: indexF4HaKeT8YelhpFDN9QRe1qO1N5nG_45vtvrI1S2jaeiGoMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiplatform/index.vue")
  },
  {
    name: "admin-multiplatform___ka",
    path: "/ka/admin/multiplatform",
    meta: indexF4HaKeT8YelhpFDN9QRe1qO1N5nG_45vtvrI1S2jaeiGoMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiplatform/index.vue")
  },
  {
    name: "admin-multiaccounts-dealers___en",
    path: "/admin/multiaccounts/dealers",
    meta: dealersXTX5N2jA2rzHqX71bcyD7nMnsykJKfr_454CR_81m8MhIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/dealers.vue")
  },
  {
    name: "admin-multiaccounts-dealers___ru",
    path: "/ru/admin/multiaccounts/dealers",
    meta: dealersXTX5N2jA2rzHqX71bcyD7nMnsykJKfr_454CR_81m8MhIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/dealers.vue")
  },
  {
    name: "admin-multiaccounts-dealers___ka",
    path: "/ka/admin/multiaccounts/dealers",
    meta: dealersXTX5N2jA2rzHqX71bcyD7nMnsykJKfr_454CR_81m8MhIMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/dealers.vue")
  },
  {
    name: "admin-multiaccounts-accounts___en",
    path: "/admin/multiaccounts/accounts",
    meta: accountsJ6MBwKDQdDs8rlT2bd50zIvkNNiup0c661CfVV8A86EMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/accounts.vue")
  },
  {
    name: "admin-multiaccounts-accounts___ru",
    path: "/ru/admin/multiaccounts/accounts",
    meta: accountsJ6MBwKDQdDs8rlT2bd50zIvkNNiup0c661CfVV8A86EMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/accounts.vue")
  },
  {
    name: "admin-multiaccounts-accounts___ka",
    path: "/ka/admin/multiaccounts/accounts",
    meta: accountsJ6MBwKDQdDs8rlT2bd50zIvkNNiup0c661CfVV8A86EMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/accounts.vue")
  },
  {
    name: "admin-multiaccounts-auctions___en",
    path: "/admin/multiaccounts/auctions",
    meta: auctionslnOa1iBldONAHxH6OhIgA_45H8ZHt847x34YF7_457bQDxcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/auctions.vue")
  },
  {
    name: "admin-multiaccounts-auctions___ru",
    path: "/ru/admin/multiaccounts/auctions",
    meta: auctionslnOa1iBldONAHxH6OhIgA_45H8ZHt847x34YF7_457bQDxcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/auctions.vue")
  },
  {
    name: "admin-multiaccounts-auctions___ka",
    path: "/ka/admin/multiaccounts/auctions",
    meta: auctionslnOa1iBldONAHxH6OhIgA_45H8ZHt847x34YF7_457bQDxcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(admin)/admin/multiaccounts/auctions.vue")
  },
  {
    name: "dealer-cars-id-service-requestedServiceId___en",
    path: "/dealer/cars/:id()/service/:requestedServiceId()",
    meta: _91requestedServiceId_93ZOD7sDpOOmtick2zDkRJGxvf1PlPfas5I2m0CTDOJA4Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/[id]/service/[requestedServiceId].vue")
  },
  {
    name: "dealer-cars-id-service-requestedServiceId___ru",
    path: "/ru/dealer/cars/:id()/service/:requestedServiceId()",
    meta: _91requestedServiceId_93ZOD7sDpOOmtick2zDkRJGxvf1PlPfas5I2m0CTDOJA4Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/[id]/service/[requestedServiceId].vue")
  },
  {
    name: "dealer-cars-id-service-requestedServiceId___ka",
    path: "/ka/dealer/cars/:id()/service/:requestedServiceId()",
    meta: _91requestedServiceId_93ZOD7sDpOOmtick2zDkRJGxvf1PlPfas5I2m0CTDOJA4Meta || {},
    component: () => import("/app/apps/crm/src/app/pages/dealer/cars/[id]/service/[requestedServiceId].vue")
  },
  {
    name: "multiplatform-theme___en",
    path: "/multiplatform/theme",
    meta: indexzPmtqb3AF38YJVOOH7hLsIVn7V60kpMaqOYukbJTB2cMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/theme/index.vue")
  },
  {
    name: "multiplatform-theme___ru",
    path: "/ru/multiplatform/theme",
    meta: indexzPmtqb3AF38YJVOOH7hLsIVn7V60kpMaqOYukbJTB2cMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/theme/index.vue")
  },
  {
    name: "multiplatform-theme___ka",
    path: "/ka/multiplatform/theme",
    meta: indexzPmtqb3AF38YJVOOH7hLsIVn7V60kpMaqOYukbJTB2cMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/theme/index.vue")
  },
  {
    name: "multiplatform-users___en",
    path: "/multiplatform/users",
    meta: indexX42c8p0LynncfbRnuVa7vaAZ9dA4UbcE_45ngcYUCr5YUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/users/index.vue")
  },
  {
    name: "multiplatform-users___ru",
    path: "/ru/multiplatform/users",
    meta: indexX42c8p0LynncfbRnuVa7vaAZ9dA4UbcE_45ngcYUCr5YUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/users/index.vue")
  },
  {
    name: "multiplatform-users___ka",
    path: "/ka/multiplatform/users",
    meta: indexX42c8p0LynncfbRnuVa7vaAZ9dA4UbcE_45ngcYUCr5YUMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/users/index.vue")
  },
  {
    name: "client-services-service-requestedClientServiceId___en",
    path: "/client-services/service/:requestedClientServiceId()",
    meta: _91requestedClientServiceId_930QOQoqJ6_45PVaMZZ_45R_xzfmcJ97naIogXEPPM_27nhLMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/client-services/service/[requestedClientServiceId].vue")
  },
  {
    name: "client-services-service-requestedClientServiceId___ru",
    path: "/ru/client-services/service/:requestedClientServiceId()",
    meta: _91requestedClientServiceId_930QOQoqJ6_45PVaMZZ_45R_xzfmcJ97naIogXEPPM_27nhLMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/client-services/service/[requestedClientServiceId].vue")
  },
  {
    name: "client-services-service-requestedClientServiceId___ka",
    path: "/ka/client-services/service/:requestedClientServiceId()",
    meta: _91requestedClientServiceId_930QOQoqJ6_45PVaMZZ_45R_xzfmcJ97naIogXEPPM_27nhLMMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/client-services/service/[requestedClientServiceId].vue")
  },
  {
    name: "multiplatform-dashboard___en",
    path: "/multiplatform/dashboard",
    meta: indexXZIHulQ8TTsEzDuAf7gwhcdq2sHVTxuQT_AwlQGGfZcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/dashboard/index.vue")
  },
  {
    name: "multiplatform-dashboard___ru",
    path: "/ru/multiplatform/dashboard",
    meta: indexXZIHulQ8TTsEzDuAf7gwhcdq2sHVTxuQT_AwlQGGfZcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/dashboard/index.vue")
  },
  {
    name: "multiplatform-dashboard___ka",
    path: "/ka/multiplatform/dashboard",
    meta: indexXZIHulQ8TTsEzDuAf7gwhcdq2sHVTxuQT_AwlQGGfZcMeta || {},
    component: () => import("/app/apps/crm/src/app/pages/(multiplatform-admin)/multiplatform/dashboard/index.vue")
  }
]